<template>
  <div class="body">
    <div class="container-avaliacao">
        <div class="titulo">Avalie a Severidade</div>
        <div class="container-card">
            <div class="card-avaliacao font-card cursor" :id="severidadeEnum.I" @click="addSeveridade(severidadeEnum.I, 0, 1)" v-b-tooltip.hover :title="'Desprezível'">I</div>
            <div class="card-avaliacao font-card cursor" :id="severidadeEnum.II" @click="addSeveridade(severidadeEnum.II, 1, 2)" v-b-tooltip.hover :title="'Marginal'">II</div>
            <div class="card-avaliacao font-card cursor" :id="severidadeEnum.III" @click="addSeveridade(severidadeEnum.III, 2, 3)" v-b-tooltip.hover :title="'Crítico'">III</div>
            <div class="card-avaliacao font-card cursor" :id="severidadeEnum.IV" @click="addSeveridade(severidadeEnum.IV, 3, 4)" v-b-tooltip.hover :title="'Catastrófico'">IV</div>
        </div>
    </div>

    <div class="container-avaliacao">
        <div class="titulo">Avalie a Probabilidade</div>
        <div class="container-card">
            <div class="card-avaliacao font-card cursor" :id="probabilidadeEnum.A" @click="addProbabilidade(probabilidadeEnum.A, 0, 1)" v-b-tooltip.hover :title="'Extremamente Remoto'">A</div>
            <div class="card-avaliacao font-card cursor" :id="probabilidadeEnum.B" @click="addProbabilidade(probabilidadeEnum.B, 1, 2)" v-b-tooltip.hover :title="'Remoto'">B</div>
            <div class="card-avaliacao font-card cursor" :id="probabilidadeEnum.C" @click="addProbabilidade(probabilidadeEnum.C, 2, 3)" v-b-tooltip.hover :title="'Pouco Provável'">C</div>
            <div class="card-avaliacao font-card cursor" :id="probabilidadeEnum.D" @click="addProbabilidade(probabilidadeEnum.D, 3, 4)" v-b-tooltip.hover :title="'Provável'">D</div>
            <div class="card-avaliacao font-card cursor" :id="probabilidadeEnum.E" @click="addProbabilidade(probabilidadeEnum.E, 4, 5)" v-b-tooltip.hover :title="'Frequente'">E</div>
        </div>
    </div>

    <div class="container-avaliacao">
        <div class="titulo">Cálculo Matriz de Risco</div>
        <div class="container-card">
            <div class="card-avaliacao font-card" :id="matrizRiscoEnum.T" v-b-tooltip.hover :title="'Tolerável'">T</div>
            <div class="card-avaliacao-M font-card-M" :id="matrizRiscoEnum.M" v-b-tooltip.hover :title="'Moderado'">M</div>
            <div class="card-avaliacao-NT font-card-NT" :id="matrizRiscoEnum.NT" v-b-tooltip.hover :title="'Não Tolerável'">NT</div>
        </div>
    </div>

    <div class="d-flex container_cancel_save" v-if="aprTemplateReprovado === false && aprTemplateAgAprovacao === false">
        <div class="criar">
            <button class="button-save" @click="adicionarAvaliacaoMatriz">ADICIONAR</button>
        </div>
    </div>
  </div>

</template>

<script>
import assessmentApr from './assessmentApr'
export default assessmentApr
</script>

<style scoped>
.body {
    padding: 0 2rem;
}
.container-avaliacao{
    margin-top: 1rem;
}
.container-card{
    display: flex;
    margin-top: 1rem;
    column-gap: 1.5rem;
}
.card-avaliacao{
    height: 4rem;
    background: #E7E7E7;
    width: 4rem;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.card-avaliacao.clicked{
    background: #CBE9CF;
}
.card-avaliacao-M {
    height: 4rem;
    background: #E7E7E7;
    width: 4rem;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.card-avaliacao-M.clicked {
    height: 4rem;
    background: #FFD8BB;
    width: 4rem;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.card-avaliacao-NT {
    height: 4rem;
    background: #E7E7E7;
    width: 4rem;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.card-avaliacao-NT.clicked {
    height: 4rem;
    background: #FFCDCD;
    width: 4rem;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.font-card{
    font: normal normal 600 13px/33px Segoe UI;
    color: #515151;
}
.font-card.clicked{
    font: normal normal 600 13px/33px Segoe UI;
    color: #1C6228;
}
.font-card-M{
    font: normal normal 600 13px/33px Segoe UI;
    color: #515151;
}
.font-card-M.clicked{
    font: normal normal 600 13px/33px Segoe UI;
    color: #BC4807;
}
.font-card-NT{
    font: normal normal 600 13px/33px Segoe UI;
    color: #515151;
}
.font-card-NT.clicked{
    font: normal normal 600 13px/33px Segoe UI;
    color: #881616;
}
.titulo{
    font: normal normal 600 14px/33px Segoe UI;
    color: #3D3D3D;
}
.cursor {
  cursor: pointer;
}
 .container_cancel_save{
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 20px;
 }

 .button-cancel{
   background-color: #b60000;
   color: white;
 }
 .button-save{
  background-color: #046437;
  color: white;
 }

.button-cancel,
.button-save{
  margin-top: 10;
  font-size: 12PX;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 100%;
  height: 40px;
}
.criar{
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/assessmentApr/assessmentApr.vue